import {
  IconMail,
  IconPhone,
  IconMapPin,
  IconCircleCheck,
  IconCrown,
  IconBuilding,
} from "@tabler/icons-react";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function ProfileHero({
  initials,
  name,
  email,
  phone,
  location,
  isVerified,
  role,
  position,
}) {
  return (
    <div className={styles.profileHero}>
      <div className={styles.heroAvatar}>{initials}</div>
      <div className={styles.heroInfo}>
        <div className={styles.heroName}>{name}</div>
        <div className={styles.heroMeta}>
          {email && (
            <div className={styles.heroMetaItem}>
              <IconMail size={14} />
              <span>{email}</span>
            </div>
          )}
          {phone && (
            <div className={styles.heroMetaItem}>
              <IconPhone size={14} />
              <span>{phone}</span>
            </div>
          )}
          {location && (
            <div className={styles.heroMetaItem}>
              <IconMapPin size={14} />
              <span>{location}</span>
            </div>
          )}
        </div>
        <div className={styles.heroBadges}>
          {isVerified && (
            <span className={`${styles.heroBadge} ${styles.verifiedBadge}`}>
              <IconCircleCheck size={12} /> Verified
            </span>
          )}
          {role && (
            <span className={`${styles.heroBadge} ${styles.roleBadge}`}>
              <IconCrown size={12} /> {role}
            </span>
          )}
          {position && (
            <span className={styles.heroBadge}>
              <IconBuilding size={12} /> {position}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}
